import { NgModule } from '@angular/core';

import { ApAccordionComponent } from './accordion.component';
import { ApAccordionItemComponent } from './item/item.component';

/**
 * @ngdoc module
 * @name ApAccordionModule
 */
@NgModule({
    imports: [ApAccordionComponent, ApAccordionItemComponent],
    exports: [ApAccordionComponent, ApAccordionItemComponent]
})
export class ApAccordionModule {}
